import {Component, NgZone, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {ToastrService} from 'ngx-toastr';
import {UsuarioViewModel} from 'src/app/api/model/conta/usuario-view-model';
import {ContaService} from 'src/app/api/module/erp/services/auth/conta.service';
import {BlogService} from 'src/app/api/module/erp/services/blog/blog.service';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {environment} from 'src/environments/environment.prod';
declare var grecaptcha: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  mostrarChat!: boolean;
  item = 0;
  itensblog: any;
  captchaToken: string | null = null;

  captchaTokenSiteKey = environment.recaptchaSiteKey;
  constructor(
    private contaService: ContaService,
    private toastr: ToastrService,
    private router: Router,
    private blogItens: BlogService,
    private zone: NgZone,
    private errorLogging: ErrorLoggingService,
  ) {}

  public usuarioVM = new UsuarioViewModel();
  @BlockUI() public blockUI!: NgBlockUI;

  public listaBlogItem = new Array<any>();
  ano: number = new Date().getFullYear();

  ngOnInit(): void {
    this.onLogout();
    if (window.location.href.includes('indicageia')) {
      window.location.href =
        'https://forms.office.com/Pages/ResponsePage.aspx?id=68I-toTCo0G0AceSI4tY06E_aCBV2RxAm8QwDfSVCt9UREFJRzNXTjZETVc3QUVBOU5XUTdJMjZHTi4u';
    }
    (window as any).captchaCallback = (token: string) => {
      this.zone.run(() => {
        this.captchaToken = token;
      });
    };

    (window as any).captchaExpired = () => {
      this.zone.run(() => {
        this.captchaToken = null;
      });
    };
  }

  ngOnDestroy(): void {
    delete (window as any).captchaCallback;
    delete (window as any).captchaExpired;
  }
  onLogout() {
    this.contaService.onlogOut();
  }

  saibaMaisGeia() {}

  navigateToSection(sectionId: any): void {
    const sectionName = document.getElementById(sectionId);
    if (sectionId === 'home') {
      if (sectionName) {
        this.router.navigateByUrl('/' + 'home');
        sectionName.scrollIntoView();
      }
    } else {
      let selector = document.querySelector('#' + sectionId);
      if (selector !== null) {
        this.router.navigate([], {fragment: '/' + sectionId});
        selector.scrollIntoView({block: 'start'});
      }
    }
  }

  sendEmailFaleConosco() {
    const captchaToken = grecaptcha.getResponse();
    if (!this.captchaToken) {
      this.toastr.error('Por favor, complete o CAPTCHA antes de enviar.', 'Aviso');
      return;
    }
    // https://geia.com.br/SendEmail?Nome="mariaTestealguma coia"&Nascimento=""&Telefone=""&Email="afonso.goomark@gmail.com"&Mensagem="Géia Atuamos no segmento de benefícios para empresas e entidades de classe"
    this.blockUI.start();
    this.contaService.onEnviarEmailEsqueceuSenha(this.usuarioVM, captchaToken).subscribe(
      (data: any) => {
        this.captchaToken = null;
        grecaptcha.reset();
        this.toastr.success('Recebemos sua mensagem, em breve entraremos em contato');
        this.blockUI.stop();
      },

      (erro: any) => {
        grecaptcha.reset();
        this.toastr.error('Lamentamos, tivemos um problema no envio do E-mail, estamos trabalhando para melhorar!');
        this.errorLogging.logError(
          'Lamentamos, tivemos um problema no envio do E-mail, estamos trabalhando para melhorar!',
          erro,
        );
      },
    );
  }
}
